import React from 'react';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Row from 'react-bootstrap/Row';
import Spinner from "react-bootstrap/Spinner";

import Header from './Header';
import Footer from './Footer';

import PhDTheses from '../cards/CardPhD';

export default class Theses extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phdOngoing: [],
			phdFinished: [],
			master: [],
			degree: [],
			loadingThesisOng: true,
			loadingThesisFin: true,
			starting: true,
			defaultTab: 'in-progress'

		};
	}

	evaluarInicio() {
		if (this.state.phdOngoing.length <= 0) {
			this.setState({ defaultTab: "finished" })
		}
		this.setState({ starting: false })
	}
	render() {
		return (
			<div className="about-page">
				<Header />
				<div className="content-theses">
					{this.state.loadingThesisFin && this.state.loadingThesisOng ? <Spinner /> :
						<div>
							{this.evaluarInicio()}
							{this.state.starting ? <Spinner /> :
								<Tabs defaultActiveKey={this.state.defaultTab} id="tab-phd-theses" className="mb-3" justify>
									<Tab eventKey="in-progress" title="In Progress">
										<Row xs={1} md={1} className="g-4">
											{this.state.loadingThesisOng ? <Spinner /> : <PhDTheses tesis={this.state.phdOngoing} id="tesisOngoing" item='10' />}
										</Row>
									</Tab>
									<Tab eventKey="finished" title="Finished">
										<Row xs={1} md={1} className="g-4">
											{this.state.loadingThesisFin ? <Spinner /> : <PhDTheses tesis={this.state.phdFinished} id="tesisFinished" item='10' />}
										</Row>
									</Tab>
								</Tabs>
							}
						</div>
					}
				</div>
				<Footer />
			</div>
		)
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		fetch(process.env.PUBLIC_URL + "/assets/json/phd_theses-ongoing.json").then(res => res.json()).then(phdOngoing => this.setState({ phdOngoing, loadingThesisOng: false }));
		fetch(process.env.PUBLIC_URL + "/assets/json/phd_theses-finished.json").then(res => res.json()).then(phdFinished => this.setState({ phdFinished, loadingThesisFin: false }));
	}
}